import { api } from 'common';

import { GetProviderFormFields } from './FormFields';
import { getProviderDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getProviderConfig: BlockConfigProps<api.FlowDefinition.GetProviderBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'provider',
  defaultConfig: {
    providerIdType: api.FlowDefinition.ProviderIDType.USER_ID,
    providerId: '',
  },
  configFields: {
    schema: api.FlowDefinition.GetProviderBlockConfigSchema,
    FormFields: GetProviderFormFields,
  },
  documentationMarkdown: getProviderDocumentationMarkdown,
};
